import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function SetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw.length < 8) { setErr("Use at least 8 characters"); return; }
    if (pw !== pw2) { setErr("Passwords don't match"); return; }
    setBusy(true);
    try { await api.post("/api/auth/set-password", { token, password: pw }); await checkAuth(); navigate("/dashboard"); }
    catch (ex) { const d = ex.response?.data?.detail; setErr(Array.isArray(d) ? d.map(x => x.msg).join(", ") : d || "Something went wrong"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 pt-16" data-testid="set-password-page">
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-xl p-8 shadow-sm w-full max-w-md space-y-4">
        <h1 className="text-2xl font-black text-slate-900">Set your password</h1>
        <p className="text-sm text-slate-500">Choose a password to finish setting up your ShopAdvisor account.</p>
        {!token && <p className="text-sm text-red-600">This link is missing its token. Use the button in your email.</p>}
        <div><Label className="text-sm">New password</Label><Input type="password" value={pw} onChange={e => setPw(e.target.value)} data-testid="set-password-input" /></div>
        <div><Label className="text-sm">Confirm password</Label><Input type="password" value={pw2} onChange={e => setPw2(e.target.value)} data-testid="set-password-confirm" /></div>
        {err && <p className="text-sm text-red-600" data-testid="set-password-error">{err}</p>}
        <button disabled={busy || !token} className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-2.5 rounded-lg disabled:opacity-50" data-testid="set-password-submit">{busy ? "Saving…" : "Save password"}</button>
      </form>
    </div>
  );
}
